<i18n>
{
	"en": {
		"cargoCarrier": "Cargo Carrier",
		"searchForCargoCarrier": "Search for cargo carrier",
		"failedToFetch": "Failed to fetch cargo carriers"
	},
	"no": {
		"cargoCarrier": "Lastebærer",
		"searchForCargoCarrier": "Søk etter lastebærer",
		"failedToFetch": "Kunne ikke hente lastebærere"
	}
}
</i18n>

<template>
	<t-multiselect
		ref="input"
		:label="$t('cargoCarrier')"
		:allItems="cargoCarriers"
		:selectedItems="selectedItems"
		:placeholder="$t('searchForCargoCarrier')"
		:itemKeys="['description', 'registrationNumber']"
		closeOnSelect
		v-bind="$attrs"
		v-on="$listeners"
	/>
</template>

<script>
import { mapActions, mapState } from './store/cargoCarriers.store.js';
import TMultiselect from '@/components/evergreen/timpex/inputs/TMultiselect';

export default {
	name: 'CargoCarriersSearchInput',
	components: { TMultiselect },
	props: {
		selectedItems: Array,
	},

	computed: {
		...mapState(['cargoCarriers']),
	},

	async created() {
		try {
			await this.getCargoCarriers();
		} catch (e) {
			this.$notify({
				type: 'error',
				title: this.$t('failedToFetch')
			});
		}
	},

	methods: {
		...mapActions(['getCargoCarriers']),
		clearInput() {
			this.$refs.input.clearInput();
		},
	},
};
</script>
